import React from "react";
import PropTypes from "prop-types";

export const withScrollReset = Component => {
  class WithScrollReset extends React.Component {
    constructor(props) {
      super(props);

      this.scrollResetDecorator = this.scrollResetDecorator.bind(this);
    }

    scrollResetDecorator(func) {
      return (...args) => {
        func(...args);
        if (this.props.tableRef?.current) {
          this.props.tableRef.current.scrollLeft = 0;
          this.props.tableRef.current.scrollTop = 0;
        }
      };
    }

    render() {
      const { onPrevious, onNext, onFirst, onLast } = this.props;
      return (
        <Component
          {...this.props}
          onPrevious={this.scrollResetDecorator(onPrevious)}
          onNext={this.scrollResetDecorator(onNext)}
          onFirst={this.scrollResetDecorator(onFirst)}
          onLast={this.scrollResetDecorator(onLast)}
        />
      );
    }
  }
  WithScrollReset.propTypes = {
    onPrevious: PropTypes.func,
    onNext: PropTypes.func,
    onFirst: PropTypes.func,
    onLast: PropTypes.func,
    tableRef: PropTypes.object,
  };

  return WithScrollReset;
};
